import React from 'react'

// export default function InProcessScheduler (): JSX.Element {
//     return <div className="badge m-0 p-2 badge-light-warning border border-warning">In-process</div>
// }

export default function InProcessScheduler ({ status = 'In-process', fontsize = '' }: { status?: string, fontsize?: string | undefined }): JSX.Element {
    return <div className={`badge badge-light-warning border border-warning text-truncate mw-100 d-inline-block ${fontsize}`}>{status}</div>
}
